"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api3ServerV1OevExtension__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "accessControlRegistry_",
                type: "address",
            },
            {
                internalType: "string",
                name: "adminRoleDescription_",
                type: "string",
            },
            {
                internalType: "address",
                name: "manager_",
                type: "address",
            },
            {
                internalType: "address",
                name: "api3ServerV1_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "updater",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "signedDataTimestampCutoff",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "auctioneer",
                type: "address",
            },
        ],
        name: "PaidOevBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconSetWithBeacons",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconWithSignedData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "updater",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "updatedValue",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "updatedTimestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedDappOevDataFeed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "Withdrew",
        type: "event",
    },
    {
        inputs: [],
        name: "AUCTIONEER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessControlRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRoleDescription",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "api3ServerV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "auctioneerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "dappIdToLastPaidBid",
        outputs: [
            {
                internalType: "address",
                name: "updater",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "signedDataTimestampCutoff",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "oevDataFeed",
        outputs: [
            {
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "signedDataTimestampCutoff",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "payOevBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "bytes[]",
                name: "signedData",
                type: "bytes[]",
            },
        ],
        name: "simulateDappOevDataFeedUpdate",
        outputs: [
            {
                internalType: "bytes32",
                name: "baseDataFeedId",
                type: "bytes32",
            },
            {
                internalType: "int224",
                name: "updatedValue",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "updatedTimestamp",
                type: "uint32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "simulateExternalCall",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "beaconIds",
                type: "bytes32[]",
            },
        ],
        name: "updateBeaconSetWithBeacons",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "bytes[]",
                name: "signedData",
                type: "bytes[]",
            },
        ],
        name: "updateDappOevDataFeed",
        outputs: [
            {
                internalType: "bytes32",
                name: "baseDataFeedId",
                type: "bytes32",
            },
            {
                internalType: "int224",
                name: "updatedValue",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "updatedTimestamp",
                type: "uint32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Api3ServerV1OevExtension__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(accessControlRegistry_, adminRoleDescription_, manager_, api3ServerV1_, overrides) {
        return super.getDeployTransaction(accessControlRegistry_, adminRoleDescription_, manager_, api3ServerV1_, overrides || {});
    }
    deploy(accessControlRegistry_, adminRoleDescription_, manager_, api3ServerV1_, overrides) {
        return super.deploy(accessControlRegistry_, adminRoleDescription_, manager_, api3ServerV1_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Api3ServerV1OevExtension__factory = Api3ServerV1OevExtension__factory;
//# sourceMappingURL=Api3ServerV1OevExtension__factory.js.map